import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './assets/style.css';

// document.addEventListener("DOMContentLoaded", function () {
//   const rootElement = document.getElementById('root'); 
//   const root = ReactDOM.createRoot(rootElement);
//   root.render(
//     <React.StrictMode>
//       <App />
//     </React.StrictMode>
//   );
// });

setTimeout(() => {
  const rootElement = document.getElementById("root");
  if (rootElement) {
      const root = ReactDOM.createRoot(rootElement);
      root.render(<React.StrictMode>
                    <App />
                  </React.StrictMode>);
  } else {
      console.error("Root element not found!");
  }
}, 1000);